var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMercadoCreditsv2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#EEE",
    d: "M24 .5c6.49 0 12.364 2.63 16.617 6.883S47.5 17.511 47.5 24c0 6.49-2.63 12.364-6.883 16.617S30.489 47.5 24 47.5c-6.49 0-12.364-2.63-16.617-6.883S.5 30.489.5 24c0-6.49 2.63-12.364 6.883-16.617S17.511.5 24 .5z",
    transform: "translate(-618 -208) translate(137 187) translate(481 21)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .5C0 .224.225 0 .5 0h3c.277 0 .5.222.5.5 0 .276-.226.5-.5.5h-3C.223 1 0 .778 0 .5M5 .5c0-.276.225-.5.5-.5h3c.276 0 .5.222.5.5 0 .276-.226.5-.5.5h-3C5.223 1 5 .778 5 .5M10 .5c0-.276.226-.5.5-.5h3c.276 0 .5.222.5.5 0 .276-.226.5-.5.5h-3c-.277 0-.5-.222-.5-.5M16 .5c0-.276.226-.5.5-.5h3c.277 0 .5.222.5.5 0 .276-.226.5-.5.5h-3c-.277 0-.5-.222-.5-.5",
    transform: "translate(-618 -208) translate(137 187) translate(481 21) translate(14 24)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-618 -208) translate(137 187) translate(481 21) translate(14 14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5697FA",
    d: "M10.797 0C8.371 0 6.4 1.97 6.4 4.397 6.4 6.824 8.37 8.8 10.797 8.8c2.427 0 4.403-1.976 4.403-4.403C15.2 1.971 13.224 0 10.797 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.724 6.533v.529c0 .078-.07.138-.153.138h-.253c-.083 0-.147-.06-.147-.138v-.523C9.188 6.437 8.8 5.746 8.8 5.26c0-.078.064-.138.146-.138h.381c.083 0 .133.066.14.126.019.199.146.733.965.733.552 0 .889-.168.889-.63 0-.962-2.406-.349-2.406-1.93 0-.666.457-1.057 1.256-1.123v-.583c0-.06.051-.114.121-.114h.311c.064 0 .12.054.12.114v.59c.858.095 1.188.642 1.188 1.105 0 .078-.07.138-.152.138h-.381c-.083 0-.133-.042-.152-.126-.045-.289-.204-.565-.794-.565-.502 0-.838.114-.838.565C9.594 4.4 12 3.775 12 5.35c0 .775-.603 1.111-1.276 1.183M4.416 18.69c0 .07-.057.127-.128.127H.512c-.071 0-.128-.056-.128-.128v-7.778c0-.072.057-.128.128-.128h3.776c.071 0 .128.056.128.128v7.778zm-.128-8.29H.512c-.287 0-.512.23-.512.51v7.78c0 .076.015.152.051.219.082.174.256.291.461.291h3.776c.287 0 .512-.23.512-.51v-7.78c0-.28-.225-.51-.512-.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5697FA",
    d: "M4.8 11.174h8.4c.493 0 1.177.33 1.177 1.206 0 .876-.663 1.268-1.206 1.268h-3.106c-.24 0-.422.113-.422.352s.153.375.381.375h3.832c2.33-2.014 3.738-3.235 4.227-3.665.734-.644 1.374-.102 1.494 0 .121.103.815.764.114 1.689-.7.925-3.156 3.995-3.531 4.448-.375.453-.832.753-2.198.753H5.158L4.8 11.174z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.6,
    height: 9.6,
    y: 9.6,
    fill: "#0763EE",
    rx: 1.68
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercadoCreditsv2);
export default __webpack_public_path__ + "static/media/mercado-creditsv2.6332a6b4e85692267a3dc3637447bfd0.svg";
export { ForwardRef as ReactComponent };